import { logout } from '@ds/swymkit/tools'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_HOME } from '~/contexts/home/router/routes'
import { ROUTE_LOGOUT } from '~/contexts/logout/router/routes'

import { getSwymUrl } from '~/features-shared/config-manager/stores/swym-config'

const LOGOUT_ROUTE: RouteRecordRaw = {
  name: ROUTE_LOGOUT.LOGOUT,
  path: '',
  beforeEnter(to, _from, next) {
    /*
      FYI

      WAFData might redirect to this route when the Passport session has expired.
      In that case, we need to handle the query param "redirectUrl" carefully.
      It contains the window.location.href value before WAFData redirected here.
     */
    let redirectUrl = to.query.redirectUrl as string | undefined

    // If, for any reason, the redirectUrl is set to the logout page, just ignore that parameter !
    if (redirectUrl && redirectUrl.includes('/logout'))
      redirectUrl = undefined

    // If there is a ticket in the URL, it means that the user just login, don't log him out again..
    if (to.query.ticket) {
      return redirectUrl ? next(redirectUrl) : next({ name: ROUTE_HOME.LANDING })
    }

    if (import.meta.env.DEV) {
      // for dev mode, we force the redirection to the current domain so we came back to the dev env after the Passport login
      return logout(redirectUrl ?? window.location.origin)
    }

    return logout(redirectUrl ?? getSwymUrl())
  },
  component: defineComponent({}) as unknown as Promise<any>,
  meta: {
    name: 'logout',
    leftNavigation: false,
  },
}

/** Register all community routes as child of "/community" namespace */
export function getRoutes() {
  return [
    LOGOUT_ROUTE,
  ]
}
